const initialState = {
  arv_market_value: "",
  rehab_amount: "",
  sq_ft_addition: "",

  property_income: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SET_EXTRA_PANEL":
      return { ...state, ...action.payload };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/reducer/extraPanels.reducer.js